import { jwtToken } from './context';

let resolveFn;
let rejectFn;
const _promise = new Promise((resolve, reject) => {
  resolveFn = resolve;
  rejectFn = reject;
});
_promise.catch(() => {});

export function resolveAuth() {
  resolveFn();
}

export function rejectAuth(err) {
  rejectFn(err);
}

export function awaitAuth() {
  if (jwtToken.token) return Promise.resolve();
  return _promise;
}
